function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import { ROLES_LIST, PERIODS, PATTERNS_VALIDATION, DATAPLEX_STATES } from '@/js/constants';
import DialogsComponent from "@/components/DialogsComponent.vue";
import dataplex_service from '@/apps/data-platform/services/data_quality/dataplex_service';
import assignments_service from "@/apps/data-platform/services/tables_views/assignments_service";
import UserSecurityService from '@/apps/data-platform/services/security/user_security_service';
import TextFieldCalendarComponent from "@/components/TextFieldCalendarComponent";
import TextFieldRecipientsComponent from "@/components/TextFieldRecipientsComponent";
import ProfilingExecutionDetailComponent from "@/apps/data-platform/modules/data_quality_dataplex/components/ProfilingExecutionDetailComponent";
export default {
  components: {
    TextFieldCalendarComponent: TextFieldCalendarComponent,
    TextFieldRecipientsComponent: TextFieldRecipientsComponent,
    ProfilingExecutionDetailComponent: ProfilingExecutionDetailComponent
  },
  data: function data() {
    return {
      numRowsAllowed: 1,
      searchInclude: '',
      searchExclude: '',
      DATAPLEX_STATES: DATAPLEX_STATES,
      PREFIX: 'INCA_dp_',
      PREFIX_ID: 'inca-dp-',
      tab: 0,
      edit: false,
      view: false,
      filters: {},
      show_detail: false,
      filter_enabled: true,
      collapse_filter: false,
      emailPattern: PATTERNS_VALIDATION.EMAIL_GENERAL,
      execution_selected: {},
      errors_recipients: [],
      last_modification_table: null,
      profiling: {
        region: 'us-central1',
        table_input: '',
        cron_utc: 'UTC-5',
        cron_type: 'UNIQUE',
        scope: 'FULL'
      },
      profiling_selected: {},
      profilings: [],
      profilings_to_filter: [],
      pagination: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      executions: [],
      pagination_executions: {
        total: 0,
        limit: 10,
        offset: 1,
        current: 1
      },
      key_table_executions: 1,
      pagination_details: {
        total: 0,
        limit: 10,
        current: 1
      },
      key_input_table_input: 1,
      key_input_table_input_last: 1,
      key_table_columns: 1,
      key_form: 1,
      key_data_scan_id: 1,
      table_input: {},
      PERIODS: PERIODS,
      alcances: [{
        text: 'Datos Completos',
        value: 'FULL'
      }, {
        text: 'Incremental',
        value: 'INCREMENTAL'
      }],
      scope_periods: [{
        text: 'SEMANAL',
        value: PERIODS.ONE_WEEK
      }, {
        text: 'QUINCENAL',
        value: PERIODS.BIWEEKLY
      }, {
        text: 'MENSUAL',
        value: PERIODS.ONE_MONTH
      }, {
        text: 'SEMESTRAL',
        value: PERIODS.SIX_MONTH
      }],
      cron_periods: [{
        text: 'SEMANAL',
        value: PERIODS.ONE_WEEK
      }, {
        text: 'QUINCENAL',
        value: PERIODS.BIWEEKLY
      }, {
        text: 'MENSUAL',
        value: PERIODS.ONE_MONTH
      }, {
        text: 'SEMESTRAL',
        value: PERIODS.SIX_MONTH
      }],
      custom_error: {
        table_input: {}
      },
      cron_hours: [],
      cron_days: [],
      cron_days_week: [{
        text: 'Lunes',
        value: 1
      }, {
        text: 'Martes',
        value: 2
      }, {
        text: 'Miercoles',
        value: 3
      }, {
        text: 'Jueves',
        value: 4
      }, {
        text: 'Viernes',
        value: 5
      }, {
        text: 'Sabado',
        value: 6
      }, {
        text: 'Domingo',
        value: 7
      }],
      numRowsTable: 0,
      rules: {
        required: function required(v) {
          return !!v || 'El campo es requerido.';
        },
        display_name: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 256 || 'Menor o igual a 256 caracteres.';
        }],
        description: [function (v) {
          return v == "" || v == undefined || v == null || v && v.length <= 1024 || 'Menor o igual a 1024 caracteres.';
        }],
        data_scan_id: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return v && v.length <= 63 || 'Menor o igual a 63 caracteres.';
        }, function (v) {
          return /^[a-z]([a-z0-9-]{0,61}[a-z0-9])?$/.test(v) || 'Solo minúsculas, empieza con una letra, puede contener letras, numero o guiones, debe terminar con una letra o número.';
        }],
        table_input: [function (v) {
          return !!v || 'El campo es requerido.';
        }, function (v) {
          return /^[a-z][a-z0-9-]*[a-z0-9].[A-Za-z_][A-Za-z0-9_]{0,1023}\.[A-Za-z_][A-Za-z0-9_]{0,1023}$/.test(v) || 'Formato Incorrecto {project.dataset.table}';
        }],
        table_output: [function (v) {
          return v == "" || v == undefined || v == null || /^[a-z][a-z0-9-]*[a-z0-9].[A-Za-z_][A-Za-z0-9_]{0,1023}\.[A-Za-z_][A-Za-z0-9_]{0,1023}$/.test(v) || 'Formato Incorrecto {project.dataset.table}';
        }]
      }
    };
  },
  watch: {
    'profiling.column_time': function profilingColumn_time(val) {
      if (!val) {
        this.profiling.column_time_from = '';
        this.profiling.column_time_until = '';
      }
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['projects', 'catalogs', 'orgs', 'isDomainItc', 'has_dataplex_active'])), {}, {
    rowsLimitText: function rowsLimitText() {
      return "Obligatorio para tablas con m\xE1s de ".concat(this.numRowsAllowed.toLocaleString(), " registros.");
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) {
        return 'col-md-9 col-sm-12';
      } else {
        return 'col-sm-12';
      }
    },
    headers_details: function headers_details() {
      return [{
        value: 'column',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.column')
      }, {
        value: 'result',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.result')
      }];
    },
    headers_executions: function headers_executions() {
      return [{
        value: 'uid',
        text: 'UID'
      }, {
        value: 'state',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.state')
      }, {
        value: 'startTime',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.date_init')
      }, {
        value: 'endTime',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.date_end')
      }, {
        value: 'actions',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.actions')
      }];
    },
    time_columns: function time_columns() {
      return this.table_input && this.table_input.schema ? this.table_input.schema.fields.filter(function (x) {
        return x.type == "DATE" || x.type == "DATETIME";
      }) : [];
    }
  }),
  created: function created() {
    if (!this.has_dataplex_active) {
      this.$router.push({
        name: 'HomePage'
      });
      return;
    }
    this.id = this.$router.currentRoute.params.id;
    this.mode = this.$route.meta.mode;
    if (this.mode == "edit") this.edit = true;
    if (this.mode == "view") this.view = true;
    if (this.id) {
      this.getProfiling();
    }
    for (var i = 0; i < 24; i++) {
      this.cron_hours.push({
        text: ("" + i).padStart(2, '0') + ":00",
        value: i
      });
    }
    for (var _i = 0; _i < 31; _i++) this.cron_days.push({
      text: _i + 1,
      value: _i + 1
    });
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    formatDate: function formatDate(data) {
      console.log(data);
      console.log(new Date(data).toLocaleString());
      if (data) return new Date(data).toLocaleString();
      return "";
    },
    getProfiling: function getProfiling() {
      var _this = this;
      dataplex_service.getProfiling({
        id: this.id
      }).then(function (response) {
        _this.profiling = response.data;
        _this.columns = response.data.columns;
        _this.onDetailTable();
        _this.listExecutions();
      });
    },
    onDetailTable: function onDetailTable() {
      var _this2 = this;
      console.log(this.profiling.table_input, this.prev_table_input);
      if (this.profiling.table_input == this.prev_table_input) return;
      this.prev_table_input = "" + this.profiling.table_input;
      var table = this.profiling.table_input.split(".");
      if (table.length != 3) return;
      var data = {
        tables: [{
          domain_table: window.userInfo.domain,
          projectId: table[0],
          datasetId: table[1],
          tableId: table[2],
          source: "bigquery"
        }]
      };
      this.custom_error.table_input.loading = true;
      assignments_service.getTablesDetails(data).then(function (response) {
        _this2.custom_error.table_input.loading = false;
        if (Object.keys(response.data).indexOf(table[0] + ":" + table[1] + "." + table[2]) != -1) {
          var item = response.data[table[0] + ":" + table[1] + "." + table[2]];
          if (item.id) {
            console.log("Encontrado: ");
            _this2.numRowsTable = item.numRows;
            console.log(_this2.numRowsTable);
            _this2.table_input_valid = true;
            _this2.custom_error.table_input.error = false;
            _this2.custom_error.table_input.message = "";
            _this2.table_input = response.data[table[0] + ":" + table[1] + "." + table[2]];
            _this2.last_modification_table = item.lastModifiedTime ? utils.formatDateTime(utils.timestampToDate(Number(item.lastModifiedTime))) : '';
            _this2.key_input_table_input_last += 1;
          } else {
            _this2.table_input_valid = false;
            _this2.custom_error.table_input.error = true;
            _this2.custom_error.table_input.message = "La tabla no es válida o no tiene acceso.";
          }
        } else {
          _this2.table_input_valid = false;
          _this2.custom_error.table_input.error = true;
          _this2.custom_error.table_input.message = "La tabla no es válida o no tiene acceso.";
        }
        _this2.key_input_table_input += 1;
      });
    },
    onValidateForm: function onValidateForm() {
      if (this.profiling.table_input.split(".").length != 3) {
        tasks.toast.error("El formato de la tabla de entrada no es correcta 'project.dataset.table'");
        return false;
      }
      if (this.profiling.table_output) {
        if (this.profiling.table_output.split(".").length != 3) {
          tasks.toast.error("El formato de la tabla de salida no es correcta 'project.dataset.table'");
          return false;
        }
      }
      return true;
    },
    onSaveProfiling: function onSaveProfiling() {
      var _this3 = this;
      if (!this.$refs.form_profiling.validate()) return;
      if (!this.onValidateForm()) return;
      this.profiling.display_name = this.PREFIX + this.profiling.display_name;
      dataplex_service.createProfiling(this.profiling).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
          _this3.onCancelar();
        } else {
          _this3.profiling.display_name = _this3.profiling.display_name.slice(_this3.PREFIX.length);
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    onUpdateProfiling: function onUpdateProfiling() {
      if (!this.$refs.form_profiling.validate()) return;
      if (!this.onValidateForm()) return;
      dataplex_service.updateProfiling(this.profiling).then(function (response) {
        if (response.success) {
          tasks.toast.success("El registro se guardó correctamente.");
        } else {
          if (response.message) {
            tasks.toast.error(response.message);
          } else {
            tasks.toast.error("No se pudo guardar el registro.");
          }
        }
      });
    },
    onCancelar: function onCancelar() {
      this.$router.push({
        name: 'DataQualityProfilingPage'
      });
    },
    listExecutions: function listExecutions() {
      var _this4 = this;
      dataplex_service.listProfilingExecutions({
        id: this.id
      }).then(function (response) {
        _this4.executions = response.data;
        _this4.pagination_executions.total = _this4.executions.length;
      });
    },
    onPingExecution: function onPingExecution(item) {
      var _this5 = this;
      var data = {
        "profiling_id": this.id,
        "execution_id": item.id
      };
      dataplex_service.pingProfilingExecution(data).then(function (response) {
        if (response.success) {
          item = response.data;
          _this5.listExecutions();
        }
      });
    },
    onViewDetailExecution: function onViewDetailExecution(item) {
      this.tab = 2;
      this.execution_selected = Object.assign({}, item);
      this.pagination_details.total = this.execution_selected.dataProfileResult && this.execution_selected.dataProfileResult.profile && this.execution_selected.dataProfileResult.profile.fields ? this.execution_selected.dataProfileResult.profile.fields.length : 0;
      this.show_detail = true;
    },
    onCloseDetail: function onCloseDetail() {
      this.show_detail = false;
    },
    objectToHtmlList: function objectToHtmlList(obj) {
      function createList(item) {
        var html = '<ul>';
        for (var key in item) {
          if (item.hasOwnProperty(key)) {
            html += "<li><strong>".concat(key, ":</strong> ");
            if (_typeof(item[key]) === 'object' && !Array.isArray(item[key])) {
              // Recursively create list for nested objects
              html += createList(item[key]);
            } else if (Array.isArray(item[key])) {
              // Create list for array elements
              html += '<ul>';
              item[key].forEach(function (element, index) {
                html += "<li>[".concat(index, "] ").concat(_typeof(element) === 'object' ? createList(element) : element, "</li>");
              });
              html += '</ul>';
            } else {
              // Add primitive values
              html += item[key];
            }
            html += '</li>';
          }
        }
        html += '</ul>';
        return html;
      }
      return createList(obj);
    },
    idNameLine: function idNameLine(name) {
      if (name.startsWith('-')) {
        name = name.substring(1);
      }
      if (name.endsWith('-')) {
        name = name.slice(0, -1);
      }
      if (name.startsWith('-') || name.endsWith('-')) {
        name = this.idNameLine(name);
      }
      return name;
    },
    onChangeName: function onChangeName(event) {
      if (this.mode != "create") return;
      //console.log(event, this.profiling.display_name)
      var name = "" + this.profiling.display_name;
      name = name.toLowerCase();
      name = name.replace(" ", "-");
      name = name.replace(/[^a-zA-Z0-9]/g, '-');
      name = name.replace("--", "-");
      name = name.replace("--", "-");
      name = name.replace("--", "-");
      if (/^\d/.test(name)) {
        name = name.substring(1);
      }
      if (/^\d/.test(name)) {
        name = name.substring(1);
      }
      if (/^\d/.test(name)) {
        name = name.substring(1);
      }
      name = this.idNameLine(name);
      this.profiling.data_scan_id = this.PREFIX_ID + "" + name;
      //console.log(this.profiling.data_scan_id)
      this.key_data_scan_id += 1;
      //this.key_form += 1
    }
  }
};